import React from 'react';
import CartMain from 'CartComponents/CartMain';
import Footer from 'Compnents2/Footer';
import Header from 'Compnents2/Header';
import MobileMenu from 'Compnents2/MobileMenu';

function Cart() {
  return (
      <div id="cart">
        <CartMain/>
        <Footer/>
      </div>
  )
}

export default Cart;
